import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { TranslateService } from '@ngx-translate/core';
import { ChatService } from '@shared/services/api/chat.service';
import { ComponentService, EventEmitterService } from '../../../../@shared/services/common';

@Component({
    selector: 'app-chat-content',
    templateUrl: './chat-content.component.html'
})
export class ChatContentComponent implements OnInit {
    // Decorator
    @ViewChild('scrollMe') scrollMe: ElementRef;
    @ViewChild('chatMessageInput') private chatMessageInput: ElementRef;
    @ViewChild('messageElement') messageElement: ElementRef;

    scrolltop: number = null;
    svgDoubleCheckIcon: string = `
<svg width="20" height="20" viewBox="0 0 24 24" fill="none"
     xmlns="http://www.w3.org/2000/svg">
  <path d="M6 12L10 16L18 8" stroke="#9C27B0" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M2 12L6 16L8 14" stroke="#9C27B0" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
    // Public
    public languageLocal: any = "";
    public activeChat: Boolean;
    public chats;
    public chatGroup;
    public userProfile;
    public chatMessage = '';
    public newChat;
    public user;
    public file;
    contacts: any[] = [];
    chatName: string;
    isSeenMessage: boolean;
    /**
     * Constructor
     *
     * @param {ChatService} _chatService
     * @param {CoreSidebarService} _coreSidebarService
     */
    constructor(private _chatService: ChatService, private _coreSidebarService: CoreSidebarService, public componentService: ComponentService, public eventEmitterService: EventEmitterService, public translateService: TranslateService) { }

    // Lifecycle Hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        let storedLang = localStorage.getItem('localLang');
        // Subscribe to Chat Change
        this._chatService.onChatOpenChange.subscribe(res => {

            this.chatMessage = '';
            this.activeChat = res;
            setTimeout(() => {
                //this.scrolltop = this.scrollMe?.nativeElement.scrollHeight;
                this.setFocusedMessageId(this.selectedMessage);
            }, 250);
        });

        // Subscribe to Selected Chat Change
        this._chatService.onChatsChange.subscribe(res => {

            this.chats = res;
            this.chatDifferentDate(this.chats);
            setTimeout(() => {
                this.scrolltop = this.scrollMe?.nativeElement.scrollHeight;
            }, 0);
        });

        // Subscribe to Selected Chat User Change
        //this._chatService.onSelectedChatUserChange.subscribe(res => {
        //    this.chatGroup = res;
        //});

        this.userProfile = this._chatService.userProfile;
        this.eventEmitterService.invokeChatName.subscribe(name => {
            this.chatName = name.chatName;
        })
        this.scrollToBottom();
        this._chatService.onSearchTextSelectedChange.subscribe(id => {
            this.selectedMessage = id;
            setTimeout(() => this.selectedMessage = 0, 2000)
        })
        this.eventEmitterService.invokeIsSeenMessageEvent.subscribe((isSeen: boolean) => {
            this.isSeenMessage = isSeen;
        })

    }

    selectedMessage = 0;
    setFocusedMessageId(id: number) {

        const messageId: string = "message-" + id;
        const messageElement: HTMLElement | null = document.getElementById(messageId);
        if (messageElement) {
            messageElement.scrollIntoView({ behavior: 'auto' });
            messageElement.classList.add('highlight');
            setTimeout(() => {
                messageElement.classList.add('hide');
            }, 2000);
            setTimeout(() => {
                messageElement.classList.remove('highlight');
                messageElement.classList.remove('hide');
            }, 3000);
        }
    }
    scrollToBottom(): void {
        if (typeof this.scrollMe != "undefined") {
            setTimeout(() => {
                this.scrollMe.nativeElement.scrollTop = this.scrollMe?.nativeElement.scrollHeight;
            }, 100);
        }
    }
    getContactPhoto(senderId: number): string {

        const contact = this._chatService.contacts.find(c => c.id == senderId);
        let senderPhoto = contact && contact.photo !== null && contact.photo !== undefined ? contact.photo : '../../../../../assets/img/default-avatar.png';
        return senderPhoto;
    }
    // Public Methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Send Chat Message
     */
    sendChatMessage() {
        if (this.chatMessage.trim() !== '') {
            const chat = this.chatMessage
            const file = this.file;
            this.chatMessage = '';
            this.clearFileInput();
            this.file = null

            this._chatService.sendChatMessage(chat, file).then(data => {
                setTimeout(() => {
                    this.scrolltop = this.scrollMe?.nativeElement.scrollHeight;
                }, 0);
            })
            const button = document.querySelector('.send');
            button.classList.add('clicked');

            setTimeout(() => {
                button.classList.remove('clicked');
            }, 0);
            const formSendMessageElement = document.querySelector('.form-send-message') as HTMLDivElement;
            formSendMessageElement.classList.remove('error');
        } else if (this.file != null) {
            const chat = this.chatMessage
            const file = this.file;
            this.chatMessage = '';
            this.clearFileInput();
            this.file = null
            this._chatService.sendChatMessage(chat, file).then(data => {
                setTimeout(() => {
                    this.scrolltop = this.scrollMe?.nativeElement.scrollHeight;
                }, 0);
            })
            const button = document.querySelector('.send');
            button.classList.add('clicked');

            setTimeout(() => {
                button.classList.remove('clicked');
            }, 0);
            const formSendMessageElement = document.querySelector('.form-send-message') as HTMLDivElement;
            formSendMessageElement.classList.remove('error');
        } else {
            const formSendMessageElement = document.querySelector('.form-send-message') as HTMLDivElement;
            formSendMessageElement.classList.add('error');
            setTimeout(() => {
                formSendMessageElement.classList.remove('error');
            }, 1500);
        }

    }

    /**
     * Toggle Sidebar Event
     *
     * @param name
     */
    toggleSidebar(name) {
        this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
    }


    /**
     * OnFileSelect Event
     * Gets file info from event
     * @param event
     */
    openFileInput() {
        const fileInput = document.getElementById('chatCustomFile');
        if (fileInput) {
            fileInput.click();
        }
    }
    onValueChangedUP($event) {
        this.file = null
        const element = event.currentTarget as HTMLInputElement;
        let fileList: FileList | null = element.files;
        if (fileList) {
            this.file = fileList[0]
        }
    }
    getAudioUrl(fileId: number) {

    }
    downloadLoading = false;
    chatMessageFileDownload(_id) {
        var a: any = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";

        this.downloadLoading = true;
        this._chatService.chatMessageFileDownload(_id).subscribe((result: any) => {
            if (result) {
                var src = "data:" + result.type + ";base64," + result.fileData;

                const blob = this.base64ToBlob(result.fileData, result.type);
                const fileURL = window.URL.createObjectURL(blob);

                a.href = fileURL;
                a.download = result.fileName;
                a.click();
                window.URL.revokeObjectURL(fileURL);
                this.downloadLoading = false;
            }
        });
    }
    base64ToBlob(base64Data, contentType = '', sliceSize = 512) {
        const byteCharacters = atob(base64Data);
        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: contentType });
    }
    allEmoji = ["&#128512;", "&#128513;", "&#128514;", "&#128516;", "&#128517;", "&#128518;", "&#128519;", "&#128520;", "&#128521;", "&#128522;", "&#128523;", "&#128524;", "&#128525;", "&#128526;", "&#128527;",
        "&#128528;", "&#128529;", "&#128530;", "&#128531;", "&#128533;", "&#128536;", "&#128544;", "&#128546;", "&#128548;", "&#128555;"];
    emojiChatPopoverOpen = false;
    toggleWithEmojiChat() {
        this.emojiChatPopoverOpen = !this.emojiChatPopoverOpen;
    }
    ani() {
        document.getElementById('plane').className = 'animation';
    }
    anitwo() {
        document.getElementById('bg').className = 'animation2';
    }
    createBlob(file) {
        return new Promise(resolve => {
            fetch(file.src)
                .then(res => res.blob())
                .then(blob => { resolve(blob) })
                .catch(err => { console.log(err) })
        });
    }

    clearFile() {
        this.clearFileInput();
        this.file = null;
    }
    clearFileInput() {
        const fileInput = document.getElementById('chatCustomFile') as HTMLInputElement;
        if (fileInput) {
            fileInput.value = ''; // Dosya input'unu temizle
        }
    }
    chatMessageSetEmoji(_emoji) {
        let myField = this.chatMessageInput.nativeElement;
        if (!(this.chatMessageInputStartPos)) {
            this.chatMessageInputStartPos = myField.selectionStart;
            this.chatMessageInputEndPos = myField.selectionEnd;
        }
        let myValueClear = this.insertAtCursor(_emoji);
        this.chatMessage = myValueClear;
    }
    insertAtCursor(myValue) {
        ////IE support
        //if (document.selection) {
        //    myField.focus();
        //    sel = document.selection.createRange();
        //    sel.text = myValue;
        //}
        ////MOZILLA and others
        //else
        //: HTMLElement 
        var txtValueEl = document.createElement('textarea');
        txtValueEl.innerHTML = myValue;

        let myField = this.chatMessageInput.nativeElement;
        if (this.chatMessageInputStartPos || this.chatMessageInputStartPos == '0') {
            myField.value = myField.value.substring(0, this.chatMessageInputStartPos)
                + txtValueEl.value
                + myField.value.substring(this.chatMessageInputEndPos, myField.value.length);
        } else {
            myField.value += txtValueEl.value;
        }
        return myField.value;
    }
    hideEmojiPopoper(e) {
        //this.chatMessageInputStartPos = null;
        //this.chatMessageInputEndPos = null;
        let myField = this.chatMessageInput.nativeElement;
        if (!(this.chatMessageInputStartPos)) {
            myField.selectionStart = this.chatMessageInputStartPos;
            myField.selectionEnd = this.chatMessageInputEndPos;
        }
        myField.focus();
    }
    chatMessageInputStartPos = null;
    chatMessageInputEndPos = null;
    chatMessageFocus() {
        let _thisPage = this;
        setTimeout(function () {
            let myField = _thisPage.chatMessageInput.nativeElement;
            _thisPage.chatMessageInputStartPos = myField.selectionStart;
            _thisPage.chatMessageInputEndPos = myField.selectionEnd;
        }, 500);

    }
    chatMessageBlur() {

    }


    previousDate: Date | null = null;
    chatDifferentDate(chats) {
        if (chats.length > 0) {
            chats[0].isDifferentDate = true;
        }

        for (let i = 0; i < chats.length; i++) {
            if (i != 0) {
                chats[i].isDifferentSender = chats[i].sender_id !== chats[i - 1].sender_id;
            } else {
                chats[i].isDifferentSender = true;
            }

            const currentDate = new Date(chats[i].created_date);
            const hours = currentDate.getHours() + 3;
            const minutes = currentDate.getMinutes();
            chats[i].currentHour = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
            if (i == chats.length - 1) {
                chats[i].isDifferentHour = true;
            } else {
                const nextCurrentDate = new Date(chats[i + 1].created_date);
                const nextHours = nextCurrentDate.getHours() + 3;
                const nextMinutes = nextCurrentDate.getMinutes();
                chats[i + 1].currentHour = `${nextHours < 10 ? '0' : ''}${nextHours}:${nextMinutes < 10 ? '0' : ''}${nextMinutes}`;
                if (chats[i].sender_id !== chats[i + 1].sender_id) {
                    chats[i].isDifferentHour = true;
                } else {
                    chats[i].isDifferentHour = chats[i].currentHour !== chats[i + 1].currentHour;
                }
            }

            chats[i].formattedDate = this.formatDateShort(currentDate);

            chats[i].isDifferentDate = this.previousDate !== null && !this.areDatesEqual(chats[i].formattedDate, this.previousDate);
            if (chats[i].isDifferentDate || i == 0) {
                chats[i].currentDate = this.getFormattedDate(chats[i].formattedDate);
                chats[i].isDifferentDate = true;

            }

            this.previousDate = chats[i].formattedDate;
        }
    }


    areDatesEqual(date1, date2): boolean {
        if (!date1 || !date2) {
            return date1 == date2;
        }

        return date1 == date2;
    }

    getFormattedDate(date): string {
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        let formattedToday = this.formatDateShort(today);
        let formattedYesterday = this.formatDateShort(yesterday)
        if (this.areDatesEqual(date, formattedToday)) {
            return this.translateService.instant('today');
        } else if (this.areDatesEqual(date, formattedYesterday)) {
            return this.translateService.instant('yesterday');
        } else {
            return date;
        }
    }

    formatDateShort(date: Date): string {
        return new Intl.DateTimeFormat('tr-TR', { day: 'numeric', month: 'numeric', year: 'numeric' }).format(date);
    }
}

